import React, {ReactNode} from 'react';
import {buttonStyles} from '../styles';

interface ButtonProps {
  children: ReactNode;
  onClick: () => void;
  variant?:
    | 'primary'
    | 'secondary'
    | 'secondarySuccess'
    | 'danger'
    | 'dangerOutline';
  disabled?: boolean;
}

export const Button = ({
  children,
  onClick,
  variant = 'primary',
  disabled = false,
}: ButtonProps) => (
  <button
    type="button"
    disabled={disabled}
    onClick={onClick}
    style={{
      ...buttonStyles.base,
      ...buttonStyles[variant],
      ...(disabled ? buttonStyles[`${variant}Disabled`] : {}),
    }}>
    {children}
  </button>
);

export default Button;



// WEBPACK FOOTER //
// ./src/pages/Other/MPP/QuestionBonus/components/Button.tsx